module.exports = __webpack_public_path__ + "img/bot_01.5ea70df8.png";